export const SEARCH_PARAM_TOKEN_KEY = "token";
